<template>
  <v-dialog
    max-width="500px"
    v-model="entityEditDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown || entityEditData.resource.fullscreenEditDialog"
    :hide-overlay="entityEditData.resource.fullscreenEditDialog"
    transition="dialog-bottom-transition"
    persistent
  >
    <v-toolbar
      dark
      color="secondary"
      :fixed="entityEditData.resource.fullscreenEditDialog"
    >
      <v-btn
        icon
        dark
        @click.native="cancel"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ entityEditData.resource.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        flat
        large
        :loading="saving"
        :disabled="saving"
        @click="save"
        v-shortkey="{win: ['cntl', 's'], mac: ['meta', 's']}"
        @shortkey="save"
      >
        שמירה
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text :class="{ 'mt-5 pa-4': entityEditData.resource.fullscreenEditDialog }">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-flex
            v-for="(f, index) in fields"
            :key="`f${index}`"
            xs12
            :lg8="entityEditData.resource.fullscreenEditDialog"
          >
            <!-- Text -->
            <v-text-field
              v-if="f.type === 'TEXT'"
              :rules="f.validationRules"
              :dir="f.ltr ? 'ltr' : 'rtl'"
              :required="f.required"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
              :hint="f.hint"
            ></v-text-field>

            <!-- Number -->
            <v-text-field
              v-if="f.type === 'NUMBER'"
              :rules="f.validationRules"
              :dir="f.ltr ? 'ltr' : 'rtl'"
              :required="f.required"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
              type="number"
              :hint="f.hint"
            ></v-text-field>

            <!-- Textarea -->
            <v-textarea
              v-if="f.type === 'TEXTAREA'"
              :rules="f.validationRules"
              :dir="f.ltr ? 'ltr' : 'rtl'"
              :required="f.required"
              v-model="editableResource[f.field]"
              :label="`${f.name}${f.required ? '*' : ''}`"
              :rows="entityEditData.resource.fullscreenEditDialog ? 12 : 3"
              auto-grow
              :hint="f.hint"
              :placeholder="f.placeholder"
            ></v-textarea>

            <!-- Date -->
            <v-text-field
              v-if="f.type === 'DATE'"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
              type="date"
            ></v-text-field>

            <!-- DateTime -->
            <v-text-field
              v-if="f.type === 'DATETIME'"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
              type="datetime-local"
              :rules="f.validationRules"
            ></v-text-field>

            <!-- Color -->
            <color-picker
              v-if="f.type === 'COLOR'"
              v-model="editableResource[f.field]"
              :original-color="editableResource[f.field]"
            />

            <!-- Icon -->
            <v-text-field
              v-if="f.type === 'ICON'"
              :rules="f.validationRules"
              :dir="f.ltr ? 'ltr' : 'rtl'"
              :required="f.required"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
            ></v-text-field>

            <!-- Icon -->
            <v-text-field
              v-if="f.type === 'IMAGE'"
              :rules="f.validationRules"
              :dir="f.ltr ? 'ltr' : 'rtl'"
              :required="f.required"
              v-model="editableResource[f.field]"
              :append-icon="f.icon"
              :label="`${f.name}${f.required ? '*' : ''}`"
              height="42px"
            ></v-text-field>

            <!-- Boolean -->
            <v-checkbox
              color="primary"
              v-if="f.type === 'BOOLEAN'"
              :label="f.name"
              :rules="f.validationRules"
              v-model="editableResource[f.field]"
            ></v-checkbox>
            <!-- <v-text-field v-if="f.type === 'BOOLEAN'" v-model="editableResource[f.field]" :label="`${f.name}${f.required ? '*' : ''}`" height="42px"></v-text-field> -->

            <!-- SELECT -->
            <v-autocomplete
              v-if="f.type === 'SELECT'"
              v-model="editableResource[f.field]"
              :items="getItems({ itemsGetter: f.itemsGetter, entitiesType: f.items })"
              :item-text="f.itemText"
              :item-value="f.itemValue"
              :return-object="false"
              :label="`${f.name}${f.required ? '*' : ''}`"
              :rules="f.validationRules"
              :multiple="f.isMultiple"
              chips
            >
              <template
                slot="selection"
                slot-scope="{ item, index }"
              >
                <v-chip v-if="index <= (f.aggregateFrom - 1 || 0)">
                  <span>{{ item[f.itemText] }}</span>
                </v-chip>
                <span
                  v-if="index === (f.aggregateFrom || 1)"
                  class="grey--text caption"
                >(+{{ editableResource[f.field].length - (f.aggregateFrom || 1) }})</span>
              </template>
            </v-autocomplete>

            <!-- ARAN -->
            <div v-if="f.type === 'ARAN'" class="mb-4">
              <div class="headline mb-2">{{ f.name }}</div>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-radio-group
                    v-model="aranOption"
                    class="mb-3"
                    @change="onAranOptionChange"
                  >
                    <v-radio
                      label="ללא ארן"
                      value="none"
                      class="mb-2"
                    ></v-radio>
                    <v-radio
                      label="ארן חדש"
                      value="new"
                      class="mb-2"
                    ></v-radio>
                    <v-radio
                      label="הוספה לארן קיים"
                      value="existing"
                      class="mb-2"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  v-if="aranOption === 'new'"
                >
                  <v-text-field
                    v-model="newAranName"
                    label="שם ארן חדש"
                    placeholder="הזן שם ארן חדש"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  v-if="aranOption === 'existing'"
                >
                  <v-autocomplete
                    v-model="selectedAran"
                    :items="arans"
                    item-text="name"
                    item-value="_id"
                    label="בחר ארן קיים"
                    :loading="loadingArans"
                    :disabled="loadingArans"
                    outlined
                    dense
                  >
                    <template
                      slot="selection"
                      slot-scope="{ item, index }"
                    >
                      {{ item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-card-actions
        v-if="entityEditData.resource.fullscreenEditDialog"
        class="pa-4"
      >
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="saving"
          @click="save"
        >שמירה</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ColorPicker from "./ColorPicker.vue";
import { format } from "date-fns";
import { mapState } from "vuex";
import generateId from "@/idGenerator";
import { getApi } from "@/api";
import { extractAranIdFromResponse } from "@/utils/aran";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      valid: true,
      
      // ARAN data
      aranOption: 'none',
      newAranName: '',
      selectedAran: null,
      arans: [],
      loadingArans: false,
    };
  },

  computed: {
    ...mapState({
      entityEditData: state => state.entityEditData
    }),
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    editableResource() {
      return this.$store.state.editableEntities[
        this.entityEditData.resource.entityType
      ][this.entityEditData.id];
    },
    fields() {
      let fields = [];
      let model = this.entityEditData.resource.model;
      for (let key of Object.keys(model)) {
        fields.push(
          Object.assign(
            {},
            {
              field: key
            },
            model[key]
          )
        );
      }
      return fields;
    },
    updatedResource() {
      let updatedResource = { _id: this.editableResource._id };
      for (let field of this.fields) {
        if (field.type === "DATETIME") {
          updatedResource[field.field] = new Date(
            this.editableResource[field.field]
          );
        } else if (field.type === "BOOLEAN") {
          updatedResource[field.field] = this.editableResource[field.field]
            ? true
            : false;
        } else {
          updatedResource[field.field] = this.editableResource[field.field];
        }
      }
      return updatedResource;
    }
  },

  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;

        // Handle ARAN creation/selection first
        let aranPromise = Promise.resolve(null);
        
        if (this.aranOption === 'new' && this.newAranName) {
          // Create new ARAN
          aranPromise = getApi()
            .then(api => {
              return api.post("/aran", {
                name: this.newAranName
              });
            })
            .then(({ data }) => {
              console.log('New ARAN created:', data);
              const aranId = extractAranIdFromResponse(data);
              if (!aranId) {
                throw new Error('לא התקבל מזהה ארן מהשרת');
              }
              return aranId;
            })
            .catch(err => {
              console.log('Error creating ARAN:', err);
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: err.response ? err.response.data.message : err.message,
                color: "error"
              });
              throw err;
            });
        } else if (this.aranOption === 'existing' && this.selectedAran) {
          aranPromise = Promise.resolve(String(this.selectedAran));
        } else if (this.aranOption === 'none') {
          // No ARAN
          aranPromise = Promise.resolve(null);
        }

        // Continue with entity saving after ARAN handling
        aranPromise
          .then(aranId => {
            // Update the entity with ARAN data
            if (aranId !== null) {
              this.editableResource.aran = aranId;
            } else if (this.aranOption === 'none') {
              this.editableResource.aran = null;
            }
            
            return this.$store.dispatch("CLEAR_CACHE");
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;
            if (this.entityEditData.mainId) {
              url = this.entityEditData.mainResource.endpoint;
              entityType = this.entityEditData.mainResource.entityType;
              schema = this.entityEditData.mainResource.schema;
              listSchema = this.entityEditData.mainResource.listSchema;
              entityId = this.entityEditData.mainId;
              entity = this.$store.state.editableEntities[
                this.entityEditData.mainResource.entityType
              ][this.entityEditData.mainId];
              isNew = false;
            } else {
              url = this.entityEditData.resource.endpoint;
              entityType = this.entityEditData.resource.entityType;
              schema = this.entityEditData.resource.schema;
              listSchema = this.entityEditData.resource.listSchema;
              entityId = this.editableResource._id;
              entity = this.updatedResource;
              isNew = this.entityEditData.isNew;
            }
            // Check if we need to create for all events
            if (this.entityEditData.createForAllEvents && this.entityEditData.allEventIds) {
              console.log('EntityEditDialog save - creating for all events:', this.entityEditData.allEventIds);
              
              // Create entities for all events
              const savePromises = this.entityEditData.allEventIds.map(eventId => {
                const entityForEvent = { ...entity, _id: generateId(), event: eventId };
                return this.$store.dispatch("SAVE_ENTITY", {
                  url,
                  entityType,
                  schema,
                  listSchema,
                  entityId: entityForEvent._id,
                  entity: entityForEvent,
                  isNew: true
                });
              });

              return Promise.all(savePromises);
            } else {
              // Normal single entity save
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: this.entityEditData.resource.name + " נשמר/ה",
              color: "success"
            });
            this.$bus.$emit("entity-saved", {
              entityType: this.entityEditData.resource.entityType
            });
          })
          .catch(err => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.response ? err.response.data.message : err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.saving = false;
            this.entityEditDialog = false;
            this.$store.commit("REMOVE_EDITABLE_ENTITIES");
          });
      }
    },
    cancel() {
      this.$store.commit("REMOVE_EDITABLE_ENTITIES");
      this.entityEditDialog = false;
    },
    getItems({ itemsGetter, entitiesType }) {
      let items = [];

      if (entitiesType) {
        if (this.$store.state.entities[entitiesType]) {
          items = Object.values(this.$store.state.entities[entitiesType]);
        }
      } else if (itemsGetter) {
        if (Array.isArray(this.editableResource[itemsGetter.depandsOn])) {
          for (let depanded of this.editableResource[itemsGetter.depandsOn]) {
            if (depanded) {
              items = items.concat(
                Object.values(
                  this.$store.getters[itemsGetter.getter](
                    depanded._id || depanded
                  )
                )
              );
            }
          }
        } else {
          let depanded = this.editableResource[itemsGetter.depandsOn];
          if (depanded) {
            items = Object.values(
              this.$store.getters[itemsGetter.getter](depanded._id || depanded)
            );
          }
        }
      }

      if (Array.isArray(items) && items.length) {
        items = items.sort((a, b) => {
          return (b.order || 0) - (a.order || 0);
        });
      }
      return items;
    },
    fetchArans() {
      this.loadingArans = true;
      this.$store.dispatch("API_GET", {
        url: "aran",
        entityType: "arans",
        schema: "aranListSchema",
        params: { limit: 0 }
      })
      .then(() => {
        this.arans = Object.values(this.$store.state.entities.arans);
        console.log('Fetched ARANs:', this.arans);
      })
      .catch(err => {
        console.log(err);
        this.$store.dispatch("SHOW_SNACKBAR", {
          text: err.response ? err.response.data.message : err.message,
          color: "error"
        });
      })
      .finally(() => {
        this.loadingArans = false;
      });
    },
    onAranOptionChange(value) {
      console.log('ARAN option changed to:', value);
      this.$set(this, 'aranOption', value);
      
      // Handle existing ARAN if the entity has one
      if (value === 'existing' && this.editableResource.aran) {
        this.selectedAran = this.editableResource.aran;
      }
    },
    initializeAranData() {
      // Initialize ARAN data based on existing entity
      if (this.editableResource.aran) {
        this.aranOption = 'existing';
        this.selectedAran = this.editableResource.aran;
      } else {
        this.aranOption = 'none';
        this.selectedAran = null;
      }
      this.newAranName = '';
    }
  },

  props: [],

  components: {
    ColorPicker
  },

  beforeMount() {
    for (let f of this.fields) {
      if (f.type === "DATE") {
        if (this.editableResource[f.field]) {
          this.editableResource[f.field] = format(
            new Date(this.editableResource[f.field]),
            "YYYY-MM-DD"
          );
        }
      }
      if (f.type === "DATETIME") {
        if (this.editableResource[f.field]) {
          this.editableResource[f.field] =
            format(new Date(this.editableResource[f.field]), "YYYY-MM-DD") +
            "T" +
            format(new Date(this.editableResource[f.field]), "HH:mm");
        }
      }
    }
    
    // Initialize ARAN data if there are ARAN fields
    const hasAranField = this.fields.some(f => f.type === 'ARAN');
    if (hasAranField) {
      this.initializeAranData();
    }
  },

  watch: {
    aranOption: {
      handler: function(newVal) {
        console.log('ARAN option watcher triggered:', newVal);
        if (newVal === 'existing' && this.arans.length === 0) {
          this.fetchArans();
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EntityEditDialog.vue